import SpaceForButton from '@/components/_common/SpaceForButtons';
import { Button, Divider } from 'antd';
import React from 'react';
import AntdFaIcon from '@/components/_common/AntdFaIcon';
import { faCopy } from '@fortawesome/free-solid-svg-icons';
import { useHistory } from 'react-router-dom';
import ButtonBack from '@/components/_common/ButtonBack';
import { hasPermissions } from '@/utils/functions/hasPermissions';
import Authorities from '@/types/Authority';

interface Props {
  partId: number;
  disabled: boolean;
}

const PartFooter: React.FC<Props> = ({ partId, disabled }) => {
  const history = useHistory();
  return (
    <>
      <Divider />

      <SpaceForButton>
        <ButtonBack
          path="/app/operational/inventory/parts"
          disabled={disabled}
        />

        <Button
          block
          type="primary"
          onClick={() =>
            history.push(`/app/operational/inventory/parts/create`)
          }
          disabled={!hasPermissions([Authorities.REGISTER_PART_ADD])}
        >
          Nova Peça
        </Button>

        <Button
          icon={<AntdFaIcon faIcon={faCopy} />}
          disabled={!hasPermissions([Authorities.REGISTER_PART_DUPLICATE])}
          onClick={() =>
            history.push(
              `/app/operational/inventory/parts/create?partId=${partId}`,
            )
          }
        >
          Replicar peça
        </Button>
      </SpaceForButton>
    </>
  );
};

export default PartFooter;
